export const fuseNavigation = [
    {
        id       : 'slider',
        title    : 'Slider',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'view_carousel',
        url      : '/slider'
    },
    {
        id       : 'product',
        title    : 'Productos',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'inventory_2',
        url      : '/product'
    },
    {
        id       : 'category',
        title    : 'Categorias',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'category',
        url      : '/category'
    },
    {
        id       : 'transaction',
        title    : 'Transacciones',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'receipt_long',
        url      : '/transaction'
    },
    {
        id       : 'section',
        title    : 'Secciones',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'dashboard',
        url      : '/section'
    },
    {
        id       : 'helpbox',
        title    : 'Centro de Ayuda',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'help_center',
        url      : '/helpbox'
    },
    {
        id       : 'pagetag',
        title    : 'Titulos',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'label',
        url      : '/pagetag'
    },
    {
        id       : 'payment-discount',
        title    : 'Descuentos Medios',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'local_offer',
        url      : '/payment-discount'
    },
    {
        id       : 'payment-installment',
        title    : 'Pagos en Cuotas',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'payment',
        url      : '/payment-installment'
    },
    {
        id       : 'product-discount',
        title    : 'Ofertas Semanales',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'star',
        url      : '/product-discount'
    },
    {
        id       : 'synonym-group',
        title    : 'Sinónimos',
        translate: 'NAV.SAMPLE.TITLE',
        type     : 'item',
        icon     : 'find_replace',
        url      : '/synonym-group'
    },
];